const STUDENT_INIT_STATE = {
  studentCourse: {
    id: null,
    name: null,
    description: null,
    imgUrl: null,
    disabled: null,
    hasResult: null,
    isDone: null,
    progressPercentage: null,
    lastRun: null,
    status: null,
    code: null,
    modules: {
      id: null,
      name: null,
      description: null,
      url: null,
      status: null,
      score: null,
      maxScore: null,
      hasPassed: null,
      progressPercentage: null,
      lastRun: null,
      nbrOfAttempts: null,
      maxActivityPoints: null,
    },
  },
  loading: false,
  fetching: false,
  fetech: false,
  error: null,
};

export function studentCourse(state = STUDENT_INIT_STATE, action = {}) {
  switch (action.type) {
    case "FETCH_STUDENT_COURSES": {
      return { ...state, fetching: true };
    }
    case "FETCH_STUDENT_COURSES_REJECTED": {
      return { ...state, fetching: false, error: action.payload };
    }
    case "FETCH_STUDENT_COURSES_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        studentCourse: action.payload,
      };
    }
    case "RUN_STUDENT_MODULE_REJECTED": {
      return { ...state, fetching: false, error: action.payload };
    }
    default: {
      return {
        ...state,
      };
    }
  }
}

export function studentResult(state = STUDENT_INIT_STATE, action = {}) {
  switch (action.type) {
    case "FETCH_STUDENT_COURSES": {
      return { ...state, fetching: true };
    }
    case "FETCH_STUDENT_COURSES_REJECTED": {
      return { ...state, fetching: false, error: action.payload };
    }
    case "FETCH_STUDENT_COURSES_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        studentCourse: action.payload,
      };
    }
    default: {
      return {
        ...state,
      };
    }
  }
}
